export default {
    celular(value) {
        if (value) {
            return value.replace(/^\d{11}$/g, function (str) {
                return `(${str.substring(0, 2)}) ${str.substring(2, 7)}-${str.substring(7, 11)}`
            })
        }
    },
    cep(value) {
        if (value) {
            return value.replace(/^\d{8}$/g, function (str) {
                return `${str.substring(0, 2)}.${str.substring(2, 5)}-${str.substring(5, 8)}`
            })
        }
    },
    cpf(value) {
        if (value) {
            return value.replace(/^\d{11}$/g, function (str) {
                return `${str.substring(0, 3)}.${str.substring(3, 6)}.${str.substring(6, 9)}-${str.substring(9, 11)}`
            })
        }
    },
    telefone(value) {
        if (value) {
            return value.replace(/^\d{10}$/g, function (str) {
                return `(${str.substring(0, 2)}) ${str.substring(2, 6)}-${str.substring(6, 10)}`
            })
        }
    },
}